import Klient from 'src/models/Klient';
import { observable } from 'mobx';

export default class RozvozPlanGUIElement {

    constructor(klient: Klient, poradi: number) {
        this.klient = klient;
        this.poradi = poradi;
    }

    public klient: Klient;
    public poradi: number;

    @observable public daysActive: boolean[] = [false, false, false, false, false];
    public daysStridave: boolean[] = [false, false, false, false, false];
    @observable public daysStridaveActive: boolean[] = [false, false, false, false, false];

}


// WEBPACK FOOTER //
// ./src/models/RozvozPlanGUIElement.tsx